///---------------------------------------------------------------------------
//! Copyright (C) ASQUARED SRL - All Rights Reserved
//* Unauthorized copying of this file, via any medium is strictly prohibited
//* Proprietary and confidential
//* Written by Alexandru Gârbacea <g99.alex@yahoo.com>, September 2022
//? @author g99.alex@yahoo.com
///---------------------------------------------------------------------------

import React from 'react'
import packageJson from '../../package.json'
import { COMPANY, PHONE_PUBLIC } from '../services/CompanyService'

const Info = () => {
  return (
    <div className='terms-wrapper'>
        <h1>Informații</h1>
        <div className='info-wrapper'>
            {/* Read from CompanyService so these can never drift from the terms again */}
            <div className='info-pane'>
                <h3>Firmă</h3>
                <div>
                    <p>{COMPANY.name}</p>
                    <p>Reg. Com. {COMPANY.regCom}</p>
                    <p>CUI {COMPANY.cui}</p>
                    {/* <p>{fullAddress()}</p> */}
                </div>
            </div>

            <div className='info-pane'>
                <h3>Contact</h3>
                <p>{COMPANY.site}</p>
                <p>{COMPANY.email}</p>
                {PHONE_PUBLIC && <p>{COMPANY.phone}</p>}
                <p>Versiunea <b>{packageJson.version}</b></p>
            </div>
        </div>
    </div>
  )
}

export default Info